import { ConfigType } from 'config-type'

const config: Partial<ConfigType> = {
  prismicPath: 'https://heinrichdanioth.cdn.prismic.io/api/v2',
  showLegalInsideMenu: true,
  languages: [
    {
      code: 'de-ch',
      name: 'Deutsch',
    },
  ],
  tabsAreClosable: false,
  showThumbnailInFullscreenOnMobile: false,
  useScrollbarForNavigation: true,
  // Max width for the section text content when user has a big screen
  sectionTextBoxWidth: 800,
  topBarButtons: {
    desktop: ['Close', 'Menu'],
    phone: ['Menu'],
  },
  modules: ['Menu', 'Main'],
  prismicModelsNamesMap: {
    page: 'chapter',
    section: 'subchapter',
    legal: 'imprint-sources-rights',
    impressumSlug: 'impressum',
    quellenSlug: 'text--und-bildquellenverzeichnis',
    dataPrivacySlug: 'datenschutz',
    subcontentNamesArray: [
      'fullscreen_subcontent_video',
      'fullscreen_subcontent_image',
      'fullscreen_subcontent_text',
      'fullscreen_subcontent_gallery',
      'fullscreen_subcontent_graphics',
      'fullscreen_subcontent_scrollytelling',
    ],
    extraChapters: ['biography'],
  },
  landingPageRoute: '/intro',
  contentUnitUrl: 'erzaehlraum',
  notFoundRoute: '/hub',
  extraRoutes: [
    {
      path: '/hub',
      component: 'Hub',
    },
    {
      path: '/aussenraum',
      component: 'Aussenraum',
    },
    {
      path: '/schauraum',
      component: 'Schauraum',
    },
    {
      path: '/biografie/:id',
      component: 'Biography',
    },
    {
      path: '/filmraum',
      component: 'Filmraum',
    },
    {
      path: '/klassenraum',
      method: () => {
        window.location.assign(`${window.location.origin}/klassenraum`)
      },
    },
  ],
}

export default config
